import { Response } from "../../common/types"

export enum EnumMemberGiftCreditRequestStatus {
  WAIT_FOR_CONFIRM = 0,
  CANCELED = 1,
  INQUIRY_PAY_WAITING = 2,
  REGISTER_USER_INFO = 3,
  WAITING_CONTRACT_SIGN = 4,
  WAIT_FOR_CHARGE = 5,
  CHARGED = 6,
  CHARGE_FAILED = 7,
  DECHARGED = 8,
  CLEARED = 9,
  NON_CLEARED = 10,
  FACILITY_CREATED = 11,
  CREATE_FACILITY_FAILED = 12,
  CLEARED_FROM_BANK = 13,
  WAIT_FOR_RECHARGE = 14,
  EXPIRED = 15
}

export interface IGiftCreditPaymentAmount {
  GiftCreditRequestGuid: number | string
}

export interface PaymentRequestPayload {
  giftCreditRequestGuid: string
  giftCode: string
}

export interface InstallmentPaymentRequestPayload {
  giftCreditRequestGuid: string
  // payAmount: string | number
}

export interface GetInquiryPaymentAmountService {
  (args: { params: IGiftCreditPaymentAmount })
}

export interface GetInquiryPaymentRequestService {
  (args: { payload: PaymentRequestPayload })
}

export interface GetInstallmentPaymentAmountService {
  (args: { params: IGiftCreditPaymentAmount })
}

export interface InstallmentPaymentRequestService {
  (args: { payload: InstallmentPaymentRequestPayload }): Response
}
